import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { TypeaheadOptions } from 'ngx-bootstrap';

@Injectable()
export class FieldService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(query?: any) {
    return this.get('/v2/fields', query);
  }

  create(body: any) {
    return this.post('/v2/field', body);
  }

  find(id) {
    return this.get('/v2/field/' + id);
  }

  update(id, body) {
    return this.put('/v2/field/' + id, body);
  }

  allField(query?: any) {
    return this.get('/v2/all-field', query);
  }

  _delete(id) {
    return this.delete('/v2/field/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Field.service.ts